module.exports = __webpack_public_path__ + "img/icon1.720bc499.svg";